module.exports = __webpack_public_path__ + "static/media/epiglow-3.9738c3ec.jpg";